import { useDispatch } from 'react-redux';

import type { AppDispatch } from 'prequalificationV2/actions/index';

export const useAppDispatch = () => useDispatch<AppDispatch>();
